<template>
  <div class="artist-home">
    <!-- banner -->
    <sbanner />

    <div class="container">
      <select-box>
        <select-colum :index="0" :filterName="'首字母'" :childItem="filterCondition1" v-model="filterIndex1"
          @change="filter1Change" />
        <!-- <select-colum 
          :index="1"
          :filterName="'责任方式'"
          :childItem="filterCondition2"
          moreBtn
          v-model="filterIndex2"
          @change="filter2Change"
          /> -->
      </select-box>

      <!-- 头像列表 -->
      <div v-if="picShow">
        <div class="people-list-show" v-if="picList">
          <template v-for="item in picList">
            <ArtistItem :showPic="true" :item="item" :showpath="showpath" />
          </template>

        </div>
        <div class="centerItem default-btn change" v-if="picListTotal > picPageIndex * 12" @click="nextPicList">
          <span class="iconfont icon-arrow-left-right-line"></span>
          <p>换一批</p>
        </div>
      </div>
      <div style="min-height:40vh; box-sizing:border-box;">
        <div class="people-list-show name-show" v-if="list && list.length > 0">
          <template v-for="item in list">
            <ArtistItem :item="item" :showpath="showpath" />
          </template>
        </div>

        <empty v-else-if="list && list.length == 0">
          <template v-slot:emptyTips>
            <div class="empty-txt">没有更多了</div>
          </template>
        </empty>

        <loading v-if="showLoading" />

        <!-- 分页器 -->
        <Pagination :key="listTotal" :total="listTotal" :curPage="pageIndex" :pageSize="pageSize" @clickPage="clickPage"
          v-if="listTotal > 0" />
      </div>
    </div>
  </div>
</template>

<script>
import sbanner from '../components/sbanner.vue'
import SelectPannel from '../components/selectModel/commonFilter.vue'
import ArtistItem from '../components/listModel/artistItem.vue'
import Pagination from '../components/pagination.vue'
import Empty from '../components/common/empty.vue'
import Loading from '../components/common/loading.vue'
import CommonFilterMult from '../components/selectModel/commonFilterMult.vue'
import SelectBox from '../components/selectSimple/select-box.vue'
import SelectColum from '../components/selectSimple/select-colum.vue'
import colums from '../colums/colums'
import mixin from '../mixin'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'artist',
  mixins: [mixin.changeUrl],
  components: {
    sbanner, Pagination, SelectPannel, ArtistItem,
    Empty,
    Loading,
    CommonFilterMult,
    SelectBox,
    SelectColum
  },
  data() {
    return {
      showpath: '',
      listTotal: 0,
      pageIndex: 1,
      pageSize: 30,
      list: null,

      picShow: true,
      picPageIndex: 1,
      picListTotal: 0,
      picList: null,
      showLoading: false,

      filterValue1: {},
      filterValue2: {},
      filterIndex1: 0,
      filterIndex2: 0,
    }
  },
  computed: {
    ...mapState({ filterCondition2: state => state.dutyList }),
    filterCondition1() {
      let arr = colums.letters.map(a => {
        if (a == '全部') {
          return { name: a, id: '' }
        }
        return { name: a, id: a }
      })
      return arr;
    }
  },
  async mounted() {
    let query = this.$route.query;
    this.pageIndex = parseInt(query.pageIndex) || 1;
    if (this.filterCondition2.length == 0) {
      await this.getDutyList();
    }
    //处理query 中筛选的数据
    if (JSON.stringify(query) != '{}') {
      if (query.firstCode) {
        this.filterIndex1 = this.filterCondition1.findIndex(item => { return item.id == query.firstCode })
        this.filterValue1 = this.filterCondition1[this.filterIndex1];
      }
      if (query.channels_id) {
        this.filterIndex2 = this.filterCondition2.findIndex(item => { return item.id == query.channels_id })
        this.filterValue2 = this.filterCondition2[this.filterIndex2];
      }
      if (!query.channels_id && !query.firstCode) {
        this._getpicTop()
      } else {
        this._getPicList()
      }
      // this._getPicList()
    } else {
      this._getpicTop();
    }
    this._getList()

    this.$api.recordApi.addListRecord('人才');
  },
  methods: {
    ...mapActions(["getDutyList"]),

    //顶部默认置顶且随机图片列表
    async _getpicTop() {
      let params = {
        // page:this.picPageIndex,
        pageSize: 12
      }
      const res = await this.$api.artistApi.getPicListTop(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: v.cover_img ? res.showpath + v.cover_img + '?x-oss-process=image/resize,m_lfit,w_200/format,webp' : '',
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.showpath = res.showpath;
      this.picList = list
      this.picListTotal = res.total;
    },

    // 获取有头像的人才
    async _getPicList() {
      this.picList = null;
      let firstCode = this.filterValue1 ? this.filterValue1.id : '';
      let channels_id = this.filterValue2 ? this.filterValue2.id : '';

      let params = {
        page: this.picPageIndex,
        pageSize: 6,
        firstCode: firstCode,
        channels_id: channels_id,
      }
      const res = await this.$api.artistApi.getPicList(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: v.cover_img ? res.showpath + v.cover_img + '?x-oss-process=image/resize,m_lfit,w_200/format,webp' : '',
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.showpath = res.showpath;
      this.picList = list
      this.picListTotal = res.total;
    },

    //获取列表
    _getList() {
      this.showLoading = true;
      this.list = null;
      let firstCode = this.filterValue1 ? this.filterValue1.id : '';
      let channels_id = this.filterValue2 ? this.filterValue2.id : '';
      let params2 = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        firstCode: firstCode,
        channels_id: channels_id,
      }

      this.$api.artistApi.getList(params2).then(res => {
        this.showpath = res.showpath;
        this.list = res.data;
        this.listTotal = res.total;
        this.showLoading = false;
      })
    },


    //有头像的数据换一批
    nextPicList() {
      if (this.picListTotal <= this.picPageIndex * 12) {
        return;
      }

      if (this.filterIndex1 == 0 && this.filterIndex2 == 0) {
        this._getpicTop()
      } else {
        this.picPageIndex++;
        this._getPicList();
      }

    },

    //页码跳转
    clickPage(info) {
      if (info.topage > 0) {
        this.pageIndex = info.topage;
        this.saveState()
      }
    },

    filter1Change(info) {
      if (typeof info == 'object') {
        this.filterValue1 = this.filterCondition1[info.index];
      } else {
        this.filterValue1 = this.filterCondition1[info];
      }

      this.pageIndex = 1;
      this.saveState()
    },
    filter2Change(info) {
      if (typeof info == 'object') {
        this.filterValue2 = this.filterCondition2[info.index];
      } else {
        this.filterValue2 = this.filterCondition2[info];
      }
      this.pageIndex = 1;
      this.saveState()
    },
    saveState() {
      let newP = {
        firstCode: this.filterValue1 ? this.filterValue1.id : '',
        channels_id: this.filterValue2 ? this.filterValue2.id : '',
        pageIndex: this.pageIndex
      }
      this.changeUrl(newP)
    },
  },
}
</script>
<style scoped >
.artist-home {
  min-height: 80vh;
}
</style>